<template lang="pug">
div
  .table-responsive.custom-table
    table.table-history
      thead
        tr
          th {{ $t('ui.date') }} 
          th {{ $t('ui.name') }}
          th {{ $t('ui.description') }}
          th {{ $t('ui.type') }}
          th {{ $t('ui.bonus_value') }}
      tbody
        template(v-if="bonusDetail.length > 0")
          tr(v-for="bonus in bonusDetail")
            td {{ $moment(bonus.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            td {{ bonus.bonus_name}}
            td(v-if="bonus.bonus_desc != null") {{ bonus.bonus_desc }}
            td(v-else) -
            td {{ bonus.bonus_type }}
            td {{ $numeral(bonus.bonus_value).format("0,0.00") }}
        template(v-else)
          tr
            td(colspan="6") {{$t('ui.no_record')}}
  .statement-mobile
    .statement-single
      template(v-if="bonusDetail.length > 0")
        .statement-single-content(v-for="bonus in bonusDetail")
          .statement-detail
            .statement-detail-left {{bonus.bonus_name}}
            .statement-detail-right.text-warning {{bonus.bonus_desc}}
          .statement-detail
            .statement-detail-left {{$t('ui.bonus')}}
            .statement-detail-right {{ bonus.bonus_value }}
          .statement-balance
            .statement-balance-left 
            .statement-balance-right {{ $moment(bonus.created_date).format("YYYY-MM-DD HH:mm:ss") }}
      template(v-else)
        .text-center.py-2 {{ $t('ui.no_record') }}
  //- #modal-promo-statement.modal(tabindex="-1" role="dialog")
    .modal-dialog(role="document")
      .modal-content
        .modal-header
          h5.modal-title {{ $t("ui.promotion_details") }}
          .arrow-left.d-block.d-lg-none(data-dismiss="modal" aria-label="Close")
            i.fas.fa-long-arrow-alt-left
          button.close.d-none.d-md-block(type="button" data-dismiss="modal" aria-label="Close")
            span(aria-hidden="true") &times;
        .modal-body
          .modal-top-info
            .modal-top-left
              .balance-text {{ $t('ui.current_balance') }}:
              .balance-amount {{ currencyCode }} {{ $numeral($store.getters.balance).format("0,0.00") }}
            .modal-top-right
              a(href="javascript:void(0);" data-dismiss="modal" data-toggle="modal" data-target="#modal-statement")
                .btn.btn-main.btn-purple {{$t("ui.statement")}}
              //- a(href="javascript:void(0);" data-dismiss="modal" data-toggle="modal" data-target="#modal-history")
              //-   .small-nav-text
              //-     | {{ $t("ui.view_transaction_history") }}
              //-     i.fas.fa-arrow-alt-circle-right
          //- ul#tabs-modal.nav(role='tablist')
            li.nav-item-promo
              a.nav-link.p-0.py-2.py-lg-4.active(data-toggle="tab" href="#promo-bonus" role="tab" aria-controls="promo-bonus" aria-selected="true")
                .row
                  .col-12.p-0.pl-lg-3.deposit-text.text-center {{ $t('ui.bonus_details') }}
            //- li.nav-item-promo
            //-   a.nav-link.p-0.py-2.py-lg-4(data-toggle="tab" href="#promo-adjustment" role="tab" aria-controls="promo-adjustment" aria-selected="false")
            //-     .row
            //-       .col-12.p-0.pl-lg-3.deposit-text.text-center {{ $t('ui.adjustment_details') }}
            //- li.nav-item-promo
            //-   a.nav-link.p-0.py-2.py-lg-4(data-toggle="tab" href="#promo-tranfer" role="tab" aria-controls="promo-tranfer" aria-selected="false")
            //-     .row
            //-       .col-12.p-0.pl-lg-3.deposit-text.text-center {{ $t('ui.transfer') }}
          .tab-content.form-wrap
            #promo-bonus.tab-pane.fade.show.active(role="tabpanel" aria-labelledby="promo-bonus")
              form.form-wrap
                .row
                  .col-12
                    //- //- desktop view
                    .table-responsive.mt-3mt-3.d-none.d-lg-block
                      table.table.table-history(width="100%")
                        tbody
                          tr
                            th(scope="col").text-left
                              .d-flex
                                .flex-grow-1 {{ $t('ui.date') }}
                            th(scope="col").text-left
                              .d-flex
                                .flex-grow-1 {{ $t('ui.name') }}
                            th(scope="col").text-left
                              .d-flex
                                .flex-grow-1 {{ $t('ui.description') }}
                            th(scope="col").text-left
                              .d-flex
                                .flex-grow-1 {{ $t('ui.type') }}
                            th(scope="col").text-left
                              .d-flex
                                .flex-grow-1 {{ $t('ui.bonus_value') }}
                          tr(v-for="bonus in bonusDetail")
                            td.text-left
                              div {{ $moment(bonus.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                            td.text-left
                              div.text-capitalize {{ bonus.bonus_name}}
                            td.text-left
                              div.text-capitalize(v-if="bonus.bonus_desc != null") {{ bonus.bonus_desc }}
                              div.text-capitalize(v-else) -
                            td.text-left
                              div {{ bonus.bonus_type }}
                            td.text-left
                              div {{ currencyCode }} {{ $numeral(bonus.bonus_value).format("0,0.00") }}
                    //- mobile view
                    .history-phone.d-block.d-lg-none
                      .history-wrap
                        .history-content
                          p.view-info.border-bottom.border-secondary.pb-2.mb-1(v-if="bonusDetail && bonusDetail == 0") {{ $t('ui.no_bonus_found') }}
                          .d-flex.history-single(v-for="bonus in bonusDetail")
                            .flex-grow-1
                              .font-weight-bold.history-type {{ bonus.bonus_name }}
                              .history-date {{ $moment(bonus.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                            .history-right
                              .font-weight-bold.history-amount.text-right {{ currencyCode }} {{ $numeral(bonus.bonus_value).format("0,0.00") }}
              .d-none.d-lg-block
                .btn-position
                  .btn-wrap
                    a(href='javascript:void(0);' data-dismiss='modal' aria-label='Close')
                      .btn.btn-main.btn-purple.btn-transaction {{ $t('ui.done') }}
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
export default {
  computed: {
    bonusDetail(){
      return this.$store.getters.promoDetails
    },
    currencyCode() {
      return this.$store.getters.currencyCode
    }
  }
}
</script>
<style lang="scss" scoped>
ul#tabs-modal li.nav-item-promo{
  width: 100%;
}
.modal-dialog {
  @media(min-width: 768px){
    max-width: 710px !important;
  } 
}
</style>
